module.exports = __webpack_public_path__ + "img/access_to_experts.6237d9a9.svg";